/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Autodraft/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import Checkbox from 'DesignSystem/Checkbox/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Autodraft({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentCaseCloser/Configuration/Steps/Rulesets/Content/Ruleset/Autodraft"
  
}) {
let rulesetStepsValueData = fromData.useDataValue({ viewPath,
context: 'ruleset',
path: 'steps',
})
let constantData = 'auto_pay'
let aggregateData = fromAggregate.includes(rulesetStepsValueData, constantData)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
 data="ruleset.steps"
 data="'auto_pay'"
 aggregate="/Data/aggregate.js includes"
 isSelected={aggregateData}
 onClick={onClick}
 marginLeft={dtSpaceXxs}
 text="AUTO DRAFT"
/>
{children}
</React.Fragment>)
}